import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home'; 
import './App.css';
import './assets/css/style.css'; 
import './assets/css/common.css'; 
import About from './pages/About';
import Topbar from './component/Topbar';
import Sidebar from './component/Sidebar';
import Login from './pages/Login';
import AddHostelOwner from './pages/AddHostelOwner';
import AllOwner from './pages/AllOwner';
import Coupon from './pages/Coupon';
import ProductAvailability from './pages/ProductAvailability';
import DeliveryCost from './pages/DeliveryCost';
import VendorApproved from './pages/VendorApproved';
import ManageSku from './pages/ManageSku';
import VendorReport from './pages/Vendor/VendorReport';
import TotalOrder from './pages/TotalOrder';
import CancelledOrder from './pages/CancelledOrder';
import PendingOrder from './pages/PendingOrder';
import ManageCategory from './pages/ManageCategory';
import CategoryBuilder from './component/CategoryBuilder';
import PackageManagement from './pages/PackageManagement';
import AllVendor from './pages/Vendor/AllVendor';
import VendorView from './pages/Vendor/VendorView';
import ActiveInactiveVendor from './pages/Vendor/ActiveInactiveVendor';
import SkuAssured from './pages/Vendor/SkuAssured';
import InterfaceControl from './pages/InterfaceControl';
import BrandManagement from './pages/BrandManagement';
import EditProduct from './pages/Product/EditProduct';
import AllOrder from './pages/Orders/AllOrder';
import ViewOrder from './pages/Orders/ViewOrder';
import ProductGallery from './pages/Product/ProductGallery';
import ProductVariant from './pages/Product/ProductVarient';
import ProductAttribute from './pages/Product/ProductAttribute';
import AllInvoice from './pages/Orders/AllInvoice';
import OrderStatus from './pages/Orders/OrderStatus';
import AllUsers from './pages/Users/AllUsers';
import UserDetail from './pages/Users/UserDetail';
import OrderDetail from './pages/Users/OrderDetail';
import Comments from './pages/Product/Comments';
import AllContactForm from './pages/AllContactForm';
import AllSupportTicketAdmin from './pages/Support/AllSupportTicketAdmin';
import AddAds from './pages/AddAds';
import CommissionByCategory from './pages/CommissionByCategory';
import Pincodes from './pages/Pincode/Pincodes';
import VendorProfile from './pages/Vendor/VendorProfile';
import VendorCancelOrder from './pages/Orders/VendorCancelOrder';


function App() {
  return (
    <Router>
      
  


      <Routes>
        <Route path="/" element={<Login />} />   
        <Route path="/dashboard" element={<Home />} />   
        <Route path="/create-hostel-owner" element={<AddHostelOwner />} />   
        <Route path="/all-owner" element={<AllOwner />} />   
        <Route path="/about" element={<About />} />   
        <Route path="/coupon" element={<Coupon />} />   
        <Route path="/product-availability" element={<ProductAvailability />} />   
        <Route path="/delivery-cost" element={<DeliveryCost />} />   
        <Route path="/approve-vendor" element={<VendorApproved />} />   
        <Route path="/sku-assured" element={<ManageSku />} />   
        <Route path="/vendor-reports" element={<VendorReport />} />   
        <Route path="/user-orders" element={<TotalOrder />} />   
        <Route path="/user-cancelled" element={<CancelledOrder />} />   
        <Route path="/pending-carts" element={<PendingOrder />} />   
        <Route path="/category-manage" element={<ManageCategory />} />   
        <Route path="/category-builder" element={<CategoryBuilder />} />   
        <Route path="/package" element={<PackageManagement />} />   
        <Route path="/comments" element={<Comments />} />   
        <Route path="/all-contact-form" element={<AllContactForm />} />   



        <Route path="/all-vendor" element={<AllVendor />} />   
        <Route path="/vendor-profile/:id" element={<VendorProfile />} />   
        <Route path="/vendor-view/:uuid" element={<VendorView />} />   
        <Route path="/vendor-status" element={<ActiveInactiveVendor />} />    
        <Route path="/interface" element={<InterfaceControl />} />
        
        <Route path="/manage-brands" element={<BrandManagement />} />    
        <Route path="/edit-product/:uuid" element={<EditProduct />} />    
        <Route path="/gallery/:uuid" element={<ProductGallery />} />    
        <Route path="/variant/:uuid" element={<ProductVariant />} />        
        <Route path="/attribute/:uuid" element={<ProductAttribute />} />        
    
 
        <Route path="/all-orders" element={<AllOrder />} />    
        <Route path="/order-view/:order_uuid" element={<ViewOrder />} />      
        <Route path="/invoices" element={<AllInvoice />} />    
        <Route path="/order-status" element={<OrderStatus />} />    
 
        <Route path="/all-users" element={<AllUsers />} />    
        <Route path="/customer-view/:uuid" element={<UserDetail />} />    
        <Route path="/order-details/:id" element={<OrderDetail />} />    
        <Route path="/all-support" element={<AllSupportTicketAdmin />} /> 
        <Route path="/admin-charges" element={<CommissionByCategory />} /> 


        <Route path="/manage-pincode" element={<Pincodes />} /> 
 

        <Route path="/ads" element={<AddAds />} />    
        <Route path="/vendor-cancel-order" element={<VendorCancelOrder />} />    

   

      </Routes>
  
    </Router>
  );
}

export default App;
